function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".icon_disapprov_a{fill:#e24c4b;}.icon_disapprov_b{fill:#3f4448;opacity:0.1;}.icon_disapprov_c,.icon_disapprov_d{fill:#fff;}.icon_disapprov_d{opacity:0.2;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  className: "icon_disapprov_a",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(0 0)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_disapprov_b",
  d: "M71.152,59.154a12.035,12.035,0,0,1-12,12,11.808,11.808,0,0,1-9.375-4.5,11.839,11.839,0,0,0,7.5,2.625,12.035,12.035,0,0,0,12-12,11.839,11.839,0,0,0-2.625-7.5A11.808,11.808,0,0,1,71.152,59.154Z",
  transform: "translate(-47.152 -47.154)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_disapprov_c",
  d: "M128.622,128.622a1.177,1.177,0,0,1-1.65,0l-3.825-3.825-3.825,3.825a1.167,1.167,0,0,1-1.65-1.65l3.825-3.825-3.825-3.825a1.167,1.167,0,0,1,1.65-1.65l3.825,3.825,3.825-3.825a1.167,1.167,0,0,1,1.65,1.65l-3.825,3.825,3.825,3.825A1.177,1.177,0,0,1,128.622,128.622Z",
  transform: "translate(-111.147 -111.147)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_disapprov_d",
  d: "M80.563,77.719c-1.2,1.2-2.773,1.649-3.372.974-.674-.674-.225-2.173.974-3.372s2.773-1.649,3.447-.974C82.211,74.946,81.762,76.52,80.563,77.719Z",
  transform: "translate(-72.825 -70.192)"
});

var SvgDisapprov = function SvgDisapprov(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDisapprov, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disapprov.69b479db.svg";
export { ForwardRef as ReactComponent };